import { Fields } from '@sweep-io/sweep-design/dist/icons';
import { QuickSearchLightboxItem } from '../../../common/quick-search-lightbox/types';

export const defaultSearchItems: QuickSearchLightboxItem<any>[] = [
  {
    id: 'status',
    title: 'Status',
    icon: <Fields />,
  },
  {
    id: 'stage',
    title: 'Stage',
    icon: <Fields />,
  },
  {
    id: 'ownerId',
    title: 'Owner Id',
    icon: <Fields />,
  },
  {
    id: 'createdDate',
    title: 'Created Date',
    icon: <Fields />,
  },
  {
    id: 'lastModifiedDate',
    title: 'Last Modified Date',
    icon: <Fields />,
  },
];
